<template>
  <div class="concentrator-strategy-time" v-loading="loading">
    <div class="head_body" style="padding-top: 10px;">
      <el-form ref="form" :model="filter" class="search_head" label-width="120px">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item :label="$t('lampStrategy.strategy_name')">
              <el-input v-model="filter.title" :placeholder="$t('lampStrategy.input_strategy_name')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('lampStrategy.strategy_type')">
              <el-select
                clearable
                :placeholder="$t('lampStrategy.select_strategy_type')"
                v-model="filter.run_model"
                style="width: 100%"
              >
                <el-option key="all" :label="$t('control.all')" value=""></el-option>
                <el-option :key="1" :label="$t('lampStrategy.system_strategy')" :value="1"></el-option>
                <el-option :key="2" :label="$t('lampStrategy.offline_strategy')" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
            <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
        <div class="group-tip">{{$t('lampStrategy.time_strategy_tip')}}</div>
      </div>
      <div class="h20"></div>
      <table class="diy-table">
        <thead>
          <tr>
            <th width="280"><div class="cell">{{$t('lampStrategy.strategy_name')}}</div></th>
            <th width="200"><div class="cell">{{$t('lampStrategy.mode')}}</div></th>
            <th><div class="cell">{{$t('lampStrategy.strategy_content')}}</div></th>
            <th width="250"><div class="cell">{{$t('control.operate')}}</div></th>
          </tr> 
        </thead>
        <tbody>
          <template v-if="tableData.length">
            <tr v-for="(item, index) in tableData" :key="index">
              <td><div class="cell">{{item.title}}</div></td>
              <td><div class="cell">{{ modelType[item.run_model] }}</div></td>
              <td>
                <div v-if="item.strategy_list.length" class="cell">
                  <div v-for="(sitem, j) in item.strategy_list" :key="j" class="times">
                    {{$t('concentrator.loop')}}{{sitem.loop_id}}：{{sitem.openTime}}({{$t('control.open')}}) - {{sitem.closeTime}}({{$t('control.close')}})
                  </div>
                </div>
                <div v-else class="cell">-</div>
              </td>
              <td> 
                <div class="cell">
                  <div class="table-last normal">
                    <span @click="(loading = true), openEditWin(item)" class="blue pointer mar-r15">{{$t('control.edit')}}</span>
                    <span @click="delItem(item.id)" class="blue pointer">{{$t('control.delete')}}</span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5">
                <div class="data-none">{{$t('system.no_data')}}</div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    

    <!--新增修改路灯策略 开始-->
    <el-dialog
      v-if="dialogVisible"
      class="normal_dialog dialog860"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="10">
              <el-form-item :label="$t('lampStrategy.strategy_name')" prop="title">
                <el-input v-model="editOne.title" :placeholder="$t('lampStrategy.input_strategy_name')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('lampStrategy.strategy_type')">
                <el-select
                  :placeholder="$t('lampStrategy.strategy_type')"
                  v-model="editOne.run_model"
                  style="width: 100%"
                  :disabled="editType === 'create'?false:true"
                >
                  <el-option :key="1" :label="$t('lampStrategy.system_strategy')" :value="1"></el-option>
                  <el-option :key="2" :label="$t('lampStrategy.offline_strategy')" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="insert-strategy">
            <div class="sub-title">{{$t('lampStrategy.strategy_content')}}</div>
            <ul class="t-head">
              <li class="bh">{{$t('control.number')}}</li>
              <li class="loop">{{$t('concentrator.loop')}}</li>
              <li class="time">【{{$t('concentrator.open_connect')}}】{{$t('control.time')}}</li>
              <li class="time">【{{$t('concentrator.close_break')}}】{{$t('control.time')}}</li>
              <li>{{$t('control.operate')}}</li>
            </ul>
            <div v-for="(item, index) in editOne.stg_list" :key="item.key" class="item-box">
              <div class="item">
                <div class="bh">{{toOrder(index+1)}}</div>
                <div class="loop loop-box">
                  <el-select
                    :placeholder="$t('concentrator.select_loop')"
                    v-model="item.loop_id"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="hindex in 6"
                      :key="hindex"
                      :label="`${$t('concentrator.loop')} ${hindex}`"
                      :value="hindex"
                    ></el-option>
                  </el-select>
                  
                </div>
                <div class="time">
                  <el-time-picker
                    :name="'picker1'+index"
                    :clearable="false"
                    v-model="item.openTime"
                    format='HH:mm'
                    :placeholder="$t('concentrator.energize_time')"
                    style="width: 100%"
                  >
                  </el-time-picker>
                </div>
                <div class="time">
                  <el-time-picker
                    :name="'picker2'+index"
                    :clearable="false"
                    v-model="item.closeTime"
                    format='HH:mm'
                    :placeholder="$t('concentrator.outage_time')"
                    style="width: 100%"
                  >
                  </el-time-picker>
                </div>
                <div class="addDel">
                  <div class="item-btn" @click="removeTime(index)"><i class="el-icon-remove"></i></div>
                  <div class="item-btn" @click="addTime"><i class="el-icon-circle-plus"></i></div>
                </div>   
              </div>
            </div>

          </div>
      
          <div class="lamp-transfer strategy-transfer">
            <el-transfer
              filterable
              :filter-placeholder="$t('concentrator.input_device_name')"
              :data="allDevices"
              :titles="[$t('concentrator.device_can'), $t('concentrator.device_have')]"
              :button-texts="[$t('control.remove'), $t('control.add')]"
              v-model="allocated"
            >
            </el-transfer>
          </div>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">{{$t('control.cancel')}}</el-button>
          <el-button v-if="editType === 'create'" type="primary" size="medium" @click="verifyItem('create')">{{$t('control.confirm')}}</el-button>
          <el-button v-if="editType === 'update'" type="primary" size="medium" @click="verifyItem('update')">{{$t('control.confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增修改路灯策略 结束 -->
  </div>
</template>
<script>
import commonJs from '@/utils/common'
import time from "@/utils/time";
import moment from "moment";
import strategyApi from "@/api/concentrator/strategy"
export default {
  name: "strategyTime",
  data() {
    return {
      loading: false,
      modelType: this.$t('lampStrategy.modelType'),
      tableData: [],
      pageInfo: {
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        strategy_type: 1,
        title: '',
        run_model: ''
      },
      cnt_all: 0,
      dialogVisible: false,
      editOneRule: {
        title: [{ required: true, message: this.$t('lampStrategy.input_strategy_name'), trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        id: '',
        title: '',
        strategy_type: 1,
        run_model: 1,
        stg_list: [
          {
            loop_id: '',
            openTime: this.numberToTime(64800),
            closeTime: this.numberToTime(21600)
          }
        ]
      },
      allDevices: [],
      allocated: []
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
  methods: {
    ...time,
    getTableData(pageIndex) {
      this.tableData = []
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          // console.log('getTableData' ,resData)
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin(index) {
      this.allDevices = []
      this.allocated = []
      if (index === "create") {
        this.editOne = {
          id: '',
          title: '',
          run_model: 1,
          strategy_type: 1,
          stg_list: [
            {
              loop_id: '',
              openTime: this.numberToTime(64800),
              closeTime: this.numberToTime(21600)
            }
          ]
        };
        this.editType = "create";
        this.dialogVisible = true;
        this.loading = false;
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          run_model: index.run_model,
          strategy_type: 1,
          stg_list: []
        };
        this.editType = "update";
        this.getStgTime(index.strategy_list)
        setTimeout(() => {
          this.dialogVisible = true;
          this.loading = false;
        }, 200)
      }
      this.getDeviceList(0);
    },
    getStgTime(arr) {
      for (let i=0; i<arr.length; i++) {
        let item_one = {
          loop_id: arr[i].loop_id,
          openTime: this.numberToTime(this.HmToNumber(arr[i].openTime)),
          closeTime: this.numberToTime(this.HmToNumber(arr[i].closeTime))
        }
        this.$set(this.editOne.stg_list, i, item_one)
      }
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    addTime() {
      if(this.editOne.stg_list.length>5){
        return this.$message.error('回路策略最多六条！');
      }
      this.editOne.stg_list.push({
        loop_id: '',
        openTime: this.numberToTime(64800),
        closeTime: this.numberToTime(21600)
      });
    },
    removeTime(index) {
      if(this.editOne.stg_list.length<=1){
        return this.$message.error(this.$t('concentrator.loop_strategy_min1'));
      }
      if (confirm(this.$t('lampStrategy.delect_time_table'))) {
        this.editOne.stg_list.splice(index, 1);
      }
    },
    verifyItem(type) {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          let stg_list = this.editOne.stg_list
          if(stg_list.length<1){
            return this.$message.error(this.$t('concentrator.loop_strategy_min1'));
          }

          if(stg_list.length>6){
            return this.$message.error(this.$t('concentrator.loop_strategy_max6'));
          }

          for(let i=0; i<stg_list.length; i++){
            if(!stg_list[i].loop_id){
              return this.$message.error(this.$t('concentrator.select_loop'));
            }
          }

          let hasDuplicates = false;
          for (let i = 0; i < stg_list.length; i++) {
            if (stg_list[i].loop_id === '') {
              continue;
            }
            
            for (let j = i + 1; j < stg_list.length; j++) {
              if (stg_list[i].loop_id === stg_list[j].loop_id) {
                hasDuplicates = true;
                break;
              }
            }
            
            if (hasDuplicates) {
              break;
            }
          }

          if (hasDuplicates) {
            return this.$message.error(this.$t('concentrator.loop_only1_strategy'));
          }

          let params = {
            title: this.editOne.title,
            strategy_type: 1,
            longitude: '',
            latitude: '',
            run_model: this.editOne.run_model,
            strategy: '',
            ids: ''
          }

          if(this.allocated.length){
            params.ids=this.allocated.toString();
          }
          let newStg_list= []
          for(let i =0; i<stg_list.length; i++){
            let item_one = {
              loop_id: stg_list[i].loop_id,
              openTime: moment(stg_list[i].openTime).format("HH:mm"),
              closeTime: moment(stg_list[i].closeTime).format("HH:mm")
            }
            newStg_list[i] = item_one
          }
          params.strategy = JSON.stringify(newStg_list);

          if (type==='create') {
            this.createItem(params)
          } else {
            this.updateItem(params)
          }
        } else {
          return false
        }
      })
    },
    createItem(params) {
      strategyApi.strategyAdd(params).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })

    },
    updateItem(params) {
      strategyApi.strategyEdit(this.editOne.id, params).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'))
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getDeviceList(id) {
      let that = this
      strategyApi.getConcentratorByStrategyId(id).then((res) => {
        if (res.data.code === 1000) {
          let arrData = []
          let resData = res.data.data
          if(resData.length){
            for (const device of resData) {
              arrData.push({
                key: device.id,
                label: device.name
              })
            }
          }
          that.allocated = []
          if(id){
            if(arrData.length){
              for (const item of arrData) {
                that.allocated.push(item.key)
              }
              that.allDevices = [...that.allDevices, ...arrData]
              that.allDevices = Array.from(new Set(that.allDevices))
            }
          }else{
            that.allDevices = arrData
            if(that.editOne.id){
              that.getDeviceList(that.editOne.id)
            }
          }
        }
      })
    },

    delItem(id) {
      this.$confirm(this.$t('lampStrategy.delete_strategy_tip'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          strategyApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$popupMessage({
                type: 'success',
                title: this.$t('control.del_success')
                // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
              })
              this.getTableData(this.pageInfo.page);
            } else {
              this.$popupMessage({
                type: 'error',
                title: this.$t('control.tip'),
                msg: res.data.message,
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    toOrder(index){
      if(index<10){
        return '0'+index
      }else{
        return index
      }
    }
  }
  
};
</script>
<style lang='less'>
@color-primary:#0c82fe;
.concentrator-strategy-time{
  padding:0 0 20px;
  .con-body{
    padding:20px 0 10px !important;
  }
  .diy-table{
    width:100%;
    border: 0;
    border-collapse: collapse;
    border-spacing: 0;
    color: #1d2129;
    tr{
      margin:0;
      padding: 0;
      border: 0;
      th,td{
        border: 0;
        border-right: 1px solid #dee0e4;
        border-bottom: 1px solid #dee0e4;
        padding: 20px 0;
        min-width: 0;
        word-break: break-all;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        background-clip: padding-box; /* Add this line */
        .cell{
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          line-height: 1.4;
          padding:5px 10px;
          font-size: 14px;
          text-align: center;
          .times{
            width:100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        &:last-child{
          border-right: 1px solid transparent;
        }
      }
      
      th{
        background-color: #f5f7f9;
        border-right: 1px solid #f5f7f9;
        border-bottom: 1px solid #dee0e4;
        .cell{
          font-size: 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      td{
        .time1{
          width:140px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .time2{
          width:140px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .icon{
          color:#bbb;
        }
      }
    }
  }
  .insert-strategy{
    color:#1d2129;
    padding-bottom: 20px;
    .sub-title{
      padding-bottom: 15px;
    }
    .t-head{
      width:100%;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      background-color: #f6f7fb;
      li{
        height:40px;
        display: flex;
        align-items: center;
        justify-content: center;
        width:60px;
        &:nth-child(2){
          width:150px;
        }
        &:last-child{
          width:150px;
        }
        &.time{
          flex: 1;
          min-width: 150px;
        }
      }
    }
    .item-box{
      width:100%;
      border-bottom: 1px solid #dcdee2;
      .item{
        display: flex;
        .bh,.loop,.time,.addDel{
          width:60px;
          border-right:1px solid #dcdee2;
          display:flex;
          align-items:center;
          justify-content:center;
          box-sizing: border-box;
          padding: 10px;
        }
        .loop,.addDel{
          width:150px;
        }
        .time{
          flex: 1;
          min-width: 150px;
        }

        .addDel{
          width:150px;
          border-right-color:#ffffff;
          .item-btn{
            width:25px;
            height:25px;
            color:@color-primary;
            font-size:22px;
            display:flex;
            align-items:center;
            justify-content:center;
            cursor:pointer;
            margin:0 8px;
          }
        }
      }
    }
  }
  
}

.strategy-transfer{
  .el-transfer__buttons{
    .el-transfer__button{
      left:100px !important;
      &:first-child{
        left: auto !important;
        right:100px !important;
      }
    }
  }
}

.w-label{
  width:50px;
  text-align: right;
  display: block;
}
</style>
